import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import Home from "@/pages/Home";
import AdminLogin from "@/pages/AdminLogin";
import AdminLeads from "@/pages/AdminLeads";
import { AuthProvider } from "@/contexts/AuthContext";
import { ThemeProvider } from "@/contexts/ThemeContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import Chatbot from "@/components/Chatbot";
import AnalyticsRouteTracker from "@/components/AnalyticsRouteTracker";

function App() {
  return (
    <div className="App">
      <ThemeProvider>
        <AuthProvider>
        <BrowserRouter>
          <AnalyticsRouteTracker />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route
              path="/admin/leads"
              element={
                <ProtectedRoute>
                  <AdminLeads />
                </ProtectedRoute>
              }
            />
          </Routes>
          <Chatbot />
        </BrowserRouter>
        <Toaster
          theme="system"
          position="bottom-right"
          toastOptions={{
            className: "!bg-white dark:!bg-slate-900 !text-slate-900 dark:!text-slate-100 !border-slate-200 dark:!border-slate-800",
          }}
        />
        </AuthProvider>
      </ThemeProvider>
    </div>
  );
}

export default App;
